module.exports = __webpack_public_path__ + "img/2.152a6de0.jpg";